import React from 'react';
import { Modal, Button, Spinner, Alert, Form, Row, Col } from 'react-bootstrap';

const CommandParamModal = ({
  show,
  onHide,
  loading,
  modalCmdObj,
  paramValues,
  onParamChange,
  onSubmit,
  retConfig,
  cmdToConfigMap,
  paramValidation,
  hasChanges = true
}) => {
  const handleClose = () => {
    onHide();
  };

  const getInputProps = (cmdKey, idx, rule) => {
    const inputProps = {};
    let helperText = '';

    if (cmdKey === 'NSERIE' && idx === 0) {
      inputProps.type = 'text';
      inputProps.inputMode = 'numeric';
      inputProps.maxLength = 5;
      helperText = 'Informe o número de série com 5 dígitos (00000 a 99999).';
    } else if (rule && (rule.type === 'int' || rule.type === 'float')) {
      inputProps.type = 'number';
      inputProps.inputMode = 'decimal';

      if (cmdKey === 'UMIRAN1' || cmdKey === 'UMIRAN2') {
        inputProps.step = '0.1';
      } else {
        inputProps.step = rule.type === 'int' ? '1' : '0.01';
      }

      if (typeof rule.min === 'number' && !rule.exclusive) {
        inputProps.min = rule.min;
      }
      if (typeof rule.max === 'number' && !rule.upperExclusive && !rule.exclusive) {
        inputProps.max = rule.max;
      }

      if (typeof rule.min === 'number' && typeof rule.max === 'number') {
        if (rule.exclusive) {
          helperText = `Permitido: entre ${rule.min} e ${rule.max} (sem incluir).`;
        } else if (rule.upperExclusive) {
          helperText = `Permitido: de ${rule.min} até menor que ${rule.max}.`;
        } else {
          helperText = `Permitido: entre ${rule.min} e ${rule.max}.`;
        }
      }
    } else {
      inputProps.type = 'text';
    }

    return { inputProps, helperText };
  };

  const getCurrentValue = () => {
    if (!modalCmdObj) return null;
    const configKey = cmdToConfigMap[modalCmdObj.cmd];
    return retConfig && configKey ? retConfig[configKey] : null;
  };

  const currentValue = getCurrentValue();
  const filledCount = Object.values(paramValues).filter(v => v && String(v).trim() !== '').length;

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered>
      <Modal.Header closeButton style={{ background: 'linear-gradient(135deg, #1c4220 0%, #8fad15 100%)', border: 'none' }}>
        <Modal.Title style={{ fontSize: '1.1rem', fontWeight: 600, color: 'white' }}>
          {modalCmdObj?.label}
          {currentValue !== null && currentValue !== undefined && (
            <span className="badge ms-2" style={{ fontSize: '0.7rem', fontWeight: 400, background: 'rgba(255,255,255,0.25)', color: 'white' }}>
              Atual: {currentValue}
            </span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ background: '#1e293b', color: '#e2e8f0', maxHeight: '70vh', overflowY: 'auto' }}>
        {modalCmdObj?.description && (
          <Alert variant="info" className="mb-3" style={{ fontSize: '0.85rem', padding: '0.75rem', background: 'rgba(59, 130, 246, 0.2)', border: '1px solid rgba(59, 130, 246, 0.3)', color: '#93c5fd' }}>
            <strong>ℹ️ Sobre:</strong> {modalCmdObj.description}
          </Alert>
        )}
        <Form onSubmit={onSubmit} id="paramForm">
          {modalCmdObj && ['CALDIAL1', 'CALCAPX1', 'CALDIAL2', 'CALCAPX2'].includes(modalCmdObj.cmd) ? (
            <>
              <Alert variant="secondary" style={{ background: 'rgba(100, 116, 139, 0.1)', border: '1px solid #475569', color: '#94a3b8', fontSize: '0.85em', marginBottom: '15px' }}>
                <strong>📊 Preencha todos os 10 pontos da curva:</strong>
              </Alert>
              <Row>
                {[...Array(10)].map((_, idx) => (
                  <Col xs={6} md={4} key={idx} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ fontSize: '0.9rem', fontWeight: 500, color: '#cbd5e1' }}>
                        Ponto {idx + 1}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="1"
                        value={paramValues[idx] || ''}
                        onChange={e => onParamChange(idx, e.target.value)}
                        placeholder={`Ex: ${10 + idx * 5}`}
                        title={`Envia: ${modalCmdObj.cmd}:${idx + 1}:valor`}
                        style={{ background: '#334155', border: '1px solid #475569', color: '#e2e8f0' }}
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </>
          ) : modalCmdObj && ['CHART1', 'CHART2'].includes(modalCmdObj.cmd) ? (
            <>
              <Alert variant="secondary" style={{ background: 'rgba(100, 116, 139, 0.1)', border: '1px solid #475569', color: '#94a3b8', fontSize: '0.85em', marginBottom: '15px' }}>
                <strong>📈 Preencha os 4 coeficientes da curva:</strong>
              </Alert>
              <Row>
                {[...Array(4)].map((_, idx) => (
                  <Col xs={12} md={3} key={idx} className="mb-3">
                    <Form.Group>
                      <Form.Label style={{ fontSize: '0.9rem', fontWeight: 500, color: '#cbd5e1' }}>
                        Coeficiente {idx + 1} {idx === 0 ? '(x³)' : idx === 1 ? '(x²)' : idx === 2 ? '(x)' : '(const)'}
                      </Form.Label>
                      <Form.Control
                        type="number"
                        step="1"
                        value={paramValues[idx] || ''}
                        onChange={e => onParamChange(idx, e.target.value)}
                        placeholder={idx === 0 ? 'Ex: 123' : idx === 1 ? 'Ex: 4567' : idx === 2 ? 'Ex: -123456' : 'Ex: 12345678'}
                        title={`Envia: ${modalCmdObj.cmd}:${idx + 1}:valor`}
                        style={{ background: '#334155', border: '1px solid #475569', color: '#e2e8f0' }}
                      />
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </>
          ) : modalCmdObj && [...Array(modalCmdObj.params)].map((_, idx) => {
            const label = modalCmdObj.paramLabels ? modalCmdObj.paramLabels[idx] : `Parâmetro ${idx + 1}`;
            const cmdKey = modalCmdObj.cmd;
            const rules = paramValidation[cmdKey];
            const rule = Array.isArray(rules) ? rules[idx] : undefined;

            const { inputProps, helperText } = getInputProps(cmdKey, idx, rule);

            return (
              <Form.Group className="mb-3" key={idx}>
                <Form.Label style={{ fontWeight: 500, color: '#cbd5e1' }}>{label}</Form.Label>
                <Form.Control
                  {...inputProps}
                  value={paramValues[idx] || ''}
                  onChange={e => onParamChange(idx, e.target.value)}
                  autoFocus={idx === 0}
                  size="lg"
                  style={{ background: '#334155', border: '1px solid #475569', color: '#e2e8f0' }}
                />
                {helperText && (
                  <Form.Text style={{ fontSize: '0.8rem', color: '#94a3b8' }}>
                    {helperText}
                  </Form.Text>
                )}
              </Form.Group>
            );
          })}
        </Form>
      </Modal.Body>
      <Modal.Footer style={{ background: '#0f172a', border: 'none' }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          style={{
            backgroundColor: 'transparent',
            color: '#6c757d',
            border: '1px solid #6c757d'
          }}
        >
          Cancelar
        </Button>
        <Button
          type="submit"
          disabled={loading || !hasChanges}
          form="paramForm"
          style={{
            backgroundColor: 'var(--brand-light-green, #8fad15)',
            color: '#fff',
            border: 'none',
            opacity: (!hasChanges && !loading) ? 0.5 : 1
          }}
        >
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              Enviando...
            </>
          ) : (
            <>
              {modalCmdObj && ['CALDIAL1', 'CALCAPX1', 'CALDIAL2', 'CALCAPX2'].includes(modalCmdObj.cmd) ? (
                <>💾 Salvar {filledCount}/10 Pontos</>
              ) : modalCmdObj && ['CHART1', 'CHART2'].includes(modalCmdObj.cmd) ? (
                <>💾 Salvar {filledCount}/4 Coeficientes</>
              ) : (
                <>💾 Salvar</>
              )}
            </>
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CommandParamModal;
